<template>
  <div class="Index">
    <div v-show="historyFlag" style=" height:calc(100% - 44px);">
      <div class="tw-index-body" ref="indexbody">
        <div id="indexmap" style="z-index:0"></div>
        <div class="btn-container">
          <van-button
            size="small" 
            type="info"
            class="btn-p"
            @touchstart="touchstartClick(item)" 
            :plain="plainActive != item.lid" 
            v-for="item in xbcLineList" 
            :key="item.lid"
          >{{ item.lineAlias }}</van-button>
        </div>
      </div>
      <div class="tw-index-bottom1" ref="indexbottom">
        <div class="tw-xlxq-body">
          <div class="tw-xlxq-body-head1">
            <div
              class="tw-xlxq-body-head1-name"
            >{{ line_name }}</div>
            <div class="tw-xlxq-body-head1-cp">
              <span>
                {{ lineTypeName }}
              </span>
            </div>
            <div class="tw-xlxq-body-btn" @click="$router.push('/xbc/detail?type=' + plainActive )" >班车时刻表</div>
          </div>
          <div class="tw-xlxq-body-time">
            <span>距离 {{ selectSite }} 最近班车:</span>
            <span>预计{{busInfoList&& busInfoList.costMinute}}分钟 {{busInfoList&& busInfoList.costStationCount}}站</span>
          </div>
          <div class="tw-xlxq-body-main">
            <div class="tw-xlxq-body-main-body">
              <div
                class="tw-xlxq-body-main-body-mid"
                :class="{ noPc: formatterNopc }"
                ref="BusItem"
              >
                <div
                  class="tw-xlxq-body-main-body-mid-item"
                  ref="busIcon"
                  v-for="(item, index) in busStationList"
                  :key="index"
                >
                  <div class="tw-xlxq-body-main-body-mid-item-icon">
                    <div>{{ item.vehiNum || '' }}</div>
                    <template>
                        <img
                          v-if="item.arriveState == '未到站' || item.arriveState == '已到站'"
                          class="item-icon-img"
                          :src="item.vehicleType == 2 ? require('../../assets/image/xbc1.png') : require('../../assets/image/xybs1.png')"
                          alt
                        />
                        <img
                          v-if="item.arriveState == '已过站'"
                          class="item-icon-img"
                          :src="item.vehicleType == 2 ? require('../../assets/image/3-1.png') : require('../../assets/image/4-1.png')"
                          alt
                        />
                    </template>
                  </div>
                  <div class="tw-xlxq-body-main-body-mid-item-line"></div>
                  <div
                    class="tw-xlxq-body-main-body-mid-item-point1"
                    v-if="selectSite == item.stationAlias"
                  >
                    <img
                      src="../../assets/image/xlt.png"
                      alt
                      width="65%"
                      height="65%"
                      style="padding-top:20%;padding-left:18%"
                    />
                  </div>
                  <div class="tw-xlxq-body-main-body-mid-item-point" v-else></div>
                  <div class="tw-xlxq-body-main-body-mid-item-arrow">
                    <van-icon name="arrow" color="#fff" size="10" />
                  </div>
                  <div
                    class="tw-xlxq-body-main-body-mid-item-text"
                    :style="
                    selectSite == item.stationAlias
                        ? 'color:#105efe'
                        : ''
                    "
                    @click="handleItemClick(item)"
                  >
                    {{ item.stationAlias }}
                  </div>
                  <div class="lwzj" v-if="sn == item.stationAliasNo">离我最近</div>
                </div>
              </div>
              <div class="remark" v-if="busInfoList.memo">备注:{{ busInfoList.memo }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="image-tabs">
      <div class="image-tabs-item">
        <img src="../../assets/image/xbc1.png" alt="">
        小白车
      </div>
      <div class="image-tabs-item">
        <img src="../../assets/image/xybs1.png" alt="">
        校园巴士
      </div>
    </div>
    <div class="tw-hide">
      <div class="tw-map-dialog-wrapper" ref="map-dialog">
        <div class="tw-title">{{ mapDialogData.stationAlias }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import moment from 'moment'
import _ from 'underscore'
import { Toast } from 'vant'
import {
  getNearStation,
  getXbcLine,
  getXbcVehicleByLine,
  getXbcVehicleRun
} from 'api/cycleCar'
import IconCar from 'images/qcfs@2x.png'
import IconCar3 from "images/xybs01.png";
import IconCar2 from "images/xbc01.png";

export default {
  name: 'Index',
  data() {
    return {
      plainActive: '',
      vehicleType: '',
      historyFlag: true,
      beginFlag: false,
      endFlag: false,
      beginend: true,
      timeFlag: false,
      overFlag: false,
      listFlag: true,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      search: {
        begin: '',
        end: '',
        time: moment(new Date()).format('YYYY-MM-DD HH:mm')
      },
      selectSite: '',
      map: null,
      distance: 1,
      position: {},
      lastMarker: null,
      siteList: [],
      mapDialogData: {},
    
      sn: '',
      timer: null,

      busStationList: [],
      pointList: [],
      busInfoList: {},
      nextStationList: [],
      runBusInfo: [],

      xbcLineList: [],
      line_name: '',
      lineTypeName: '',
      InfoWindow: null,
      markerList: []
    }
  },
  computed: {
    formatterNopc() {
      const version = window.navigator.appVersion
      return !(version.includes('Intel Mac OS') || version.includes('Windows'))
    }
  },
  mounted() {
    this.getXbcLine()
  },
  methods: {
    // 线路切换事件
    touchstartClick(val) {
      this.plainActive = val.lid
      this.vehicleType = val.vehicleType
      this.line_name = val.lineAlias
      this.lineTypeName = val.lineTypeName
      this.findXbcVehicleByLine()
      this.busStationList = this.getStationList(this.xbcLineList)
      this.pointList = this.getPointList(this.xbcLineList)
      this.initMap()
    },
    // 获取小白车线路上的车辆定位
    findXbcVehicleByLine(){
      const params = new URLSearchParams()
      params.append('lid', this.plainActive)
      params.append('vehicleType',this.vehicleType)
      getXbcVehicleByLine(params).then(res=>{
        this.xbcLineLonlat = res.data
      if(this.map) this.map.remove(this.markerList)
        for (let j = 0; j < res.data.length; j++) {
          const item = res.data[j];
          const marker = this.addMarker(item)
          this.markerList.push(marker)
        }
        
      })
    },
    addMarker(item) {
      // if(this.map) this.map.clearMap()
      const size =new AMap.Size(12, 24)
      let iconImage = ''
      if(item.vehicleType == 2){
        iconImage = IconCar2
      }
      if(item.vehicleType == 3){
        iconImage = IconCar3
      }
      var icon = new AMap.Icon({ image: iconImage, size, imageSize: size })
        this.marker = new AMap.Marker({
            icon: icon,
            anchor:'center',
            position: [item.px, item.py],
            angle: item.direction,
            // offset: new AMap.Pixel(-13, -30)
        });
        this.marker.setMap(this.map);
      return this.marker
    },
    // 获取线路信息
    getXbcLine(){
      getXbcLine().then(res => {
        this.xbcLineList = res.data
        this.plainActive = res.data && res.data[0].lid
        this.vehicleType = res.data && res.data[0].vehicleType
        this.line_name = res.data && res.data[0].lineAlias
        this.lineTypeName = res.data && res.data[0].lineTypeName
        this.findXbcVehicleByLine()
        this.busStationList = this.getStationList(res.data)
        this.pointList = this.getPointList(res.data)
        this.initMap()
      })
    },
    //获取所有站点列表
    getStationList(list) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if(element.lid == this.plainActive){
          let arr = element.stationList.filter(item =>{ if(item && item.stationAliasNo) return item})
          return arr
        }
      }
      return []
    },
    //获取线路经纬度
    getPointList(list) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if(element.lid == this.plainActive){
          return element.pointList
        }
      }
      return []
    },
    //加载地图
    initMap() {
      var _self = this
      this.map = new window.AMap.Map('indexmap', {
        // mapStyle: "amap://styles/fresh",
        // resizeEnable: true,
        zoom: 20,
        center:[120.08,30.30]
      })
      this.map.clearMap()
      var pathParam = _.map(this.pointList, item => [item.px , item.py])
      if(pathParam.length){
        var newLine = new AMap.Polyline({
          path:pathParam,
          strokeWeight:8,
          strokeOpacity:0.8,
          strokeColor:'#0091ea',
          showDir:true
        })
        this.map.add(newLine)
      }

          this.map.setFitView()

      if (this.$store.state.position.lat !== '') {
        this.overFlag = false
        this.position = this.$store.state.position
        this.addLocation()
        return
      }
      var geolocation = new window.AMap.Geolocation({
        enableHighAccuracy: true, //是否使用高精度定位，默认:true
        timeout: 10000, //超过10秒后停止定位，默认：5s
        buttonPosition: 'RB', //定位按钮的停靠位置
        buttonOffset: new window.AMap.Pixel(10, 20) //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        // zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
      })
      // this.map.addControl(geolocation)
      geolocation.getCurrentPosition(function(status, result) {
        if (status == 'complete') {
          _self.onComplete(result)
        } else {
          _self.onError(result)
        }
      })
    },
    markerClick(e){
      let val = e.target.getExtData()
      this.InfoWindow.setText(`<div style="background: #3bacff;padding: 2px 5px">${val.stationAlias}</div>`)
      this.InfoWindow.setPosition([val.stationLong, val.stationLat])
      this.handleItemClick(val)
    },
    onComplete(res) {
      this.position = this.$store.state.position = res.position
      this.addLocation()
    },
    onError() {
      Toast('定位失败!')
    },
    //定位打点
    addLocation() {
      const {lat,lng} = this.position
      const myIcon = new AMap.Icon({image: require('../../assets/image/我的位置.png')})
      var myMarker = new AMap.Marker({
        position: [lng,lat],
        icon: myIcon
      })
      myMarker.setMap(this.map)
      this.getNearStation()
    },
    //显示附近的站点
    getNearStation() {
      this.overFlag = false
      const params = new URLSearchParams()
      params.append('lat', this.position.lat)
      params.append('lon', this.position.lng)
      params.append('lid',this. plainActive)
      params.append('vehicleType',this. vehicleType)
      getNearStation(params).then(res => {
        if (res.data.success == true) {
          this.siteList = [res.data.data]
          this.recentSites([res.data.data])
        }
      })
    },
    //遍历判断最近站点
    recentSites(data) {
      var stationname = ''
      var sn = ''
      var dis = 10000000000
      for (let i = 0; i < data.length; i++) {
        if (dis > data[i].distance) {
          dis = data[i].distance
          stationname = data[i].station_alias
          sn = data[i].station_alias_no
          this.position.lat = data[i].station_lat
          this.position.lng = data[i].station_long
        }
      }
      this.selectSite = stationname
      this.sn = sn
      this.getItvelInfo()
      this.InfoWindow = new AMap.Text({ text: '',cursor:'pointer', offset: new AMap.Pixel(0, -30) })
      for (let j = 0; j < this.busStationList.length; j++) {
          const val = this.busStationList[j];
          var marker =  new AMap.Marker({
                icon: new AMap.Icon({ image: require('../../assets/image/station.png'), size: [24,24], imageSize: [24,24] }) ,
                // icon:  require('../../assets/image/station.png'),
                position: [val.stationLong, val.stationLat],
                offset: new AMap.Pixel(-13, -30),
                extData: val
            });
            marker.on('click',this.markerClick)
            marker.setMap(this.map)
            if(val.stationAliasNo == this.sn){
              this.InfoWindow.setText(`<div style="background: #3bacff;padding: 2px 5px">${val.stationAlias}</div>`)
              this.InfoWindow.setPosition([val.stationLong, val.stationLat])
              this.InfoWindow.setMap(this.map)
            }
        }
        this.map.setFitView()
    },
    //定时
    getItvelInfo(val) {
      if(this.timer){
        clearInterval(this.timer)
        this.timer = null
      }
      this.findXbcVehicleRun(val)
      this.timer = setInterval(() => {
        this.findXbcVehicleRun(val)
        this.findXbcVehicleByLine()
      }, 5000)
    },
    findXbcVehicleRun(val){
      const params = new URLSearchParams()
      params.append('lid', this.plainActive)
      params.append('stationAliasNo', val || this.sn)
      params.append('vehicleType',this.vehicleType)
      getXbcVehicleRun(params).then(res => {
        this.listFlag = false
        let list = res.data.filter(item=> item.arriveState != '已过站').sort((a,b)=> a.costMinute - b.costMinute)
        this.busInfoList = list.length ? list[0] : {}
        let id = val || this.sn
        for (let i = 0; i < this.busStationList.length; i++) {
          let element = this.busStationList[i];
          this.busStationList[i] = Object.assign(element, {vehiNum:'',arriveState:'',costMinute: '',costRice: '',costStationCount: '', nextState: '', nextStation: '', vehicleType: ''})
          for (let j = 0; j < res.data.length; j++) {
            const item = res.data[j];
            if(item.arriveState == '已到站'){
              if(element.stationAliasNo == id){
                element = Object.assign(element, item)
                console.log(element,'已到站');
              }
            }
            if(item.arriveState == '未到站'){
              if(element.stationAliasNo == id){
                let index = item.costStationCount > 0 ? (i-item.costStationCount > 0 ? i-item.costStationCount + 1 : 0) : i
                this.busStationList[index] = Object.assign(this.busStationList[index], item)
                console.log(element,'未到站',index);
              }
            }
            if(item.arriveState == '已过站'){
              if(element.stationAliasNo == item.nextStation) {
                element = Object.assign(element, item)
                console.log(element,'已过站');
              }
            }
          }
        }
        console.log(this.busStationList);
      })
    },

    // 班车点击事件
    handleItemClick(val){
      this.selectSite = val.stationAlias
      // this.sn = val.stationAliasNo
      this.getItvelInfo(val.stationAliasNo)
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
}
</script>
<style lang="scss" scoped>
.image-tabs{
  display: flex;
  justify-content: space-around;
  &-item{
    font-size: 16px;
    display: flex;
    align-items: center;
    img{
      display: inline-block;
      margin-right: 10px;
      width: 50px;
      height: 20px;
    }
  }
}

.tw-index-body {
  position: relative;
  height: 50%;
  .btn-container {
    position: absolute;
    left: 5px;
    top: 5px;
    .btn-p {
      margin: 0 8px;
    }
  }
}
.tw-index-bottom1{
  height: 50%;
}
.Index {
  position: relative;
}
.van-search {
  padding: 0;
  height: 100%;
}
#indexmap {
  height: 100%;
  z-index: 3;
}

.icon-right_2 {
  font-size: 10px;
}

.icon-search {
  font-size: 24px;
  color: #0b84f5;
  margin: 10px 0 0 10px;
}

.timepicker {
  z-index: 101;
  height: 32%;
  width: 100%;
  position: absolute;
  bottom: 0px;
}
.tw-hide {
  display: none;
}

.listOver {
  z-index: 105;
  // height: calc(100% - 55px);
  box-sizing: border-box;
  padding: 10px;
}

.station-icon {
  width: 30px;
  height: 30px;
  padding-top: 10px;
}

.bus-icon {
  width: 15px;
  height: 10px;
  padding-left: 7px;
}

.timeTable {
  margin: 2px;
  height: 34px;
  line-height: 17px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background-color: #0089f1;
  cursor: pointer;
  border-radius: 10px;
}
.tw-xlxq {
  position: relative;
  height: 100%;
  &-head {
    height: 50px;
    background-color: #fff;
    position: relative;
    border-bottom: 1px solid #ebeced;
    &-title {
      // text-align: center;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 2px;
      padding-top: 5%;
      padding-left: 10%;
      color: #33639e;
      box-sizing: border-box;
    }
    &-icon {
      position: absolute;
      left: 2%;
      top: 30%;
    }
    &-right {
      position: absolute;
      right: 28px;
      top: 12%;
      width: 25px;
      height: 25px;
      &-text {
        display: inline-block;
        width: 50px;
        margin-left: -10px;
        font-size: 10px;
        color: #9a9fa5;
        // color: #105efe;
      }
    }
  }
  &-body {
    height: calc(100% - 0px);
    overflow: auto;
    &-head1 {
      height: 40px;
      display: flex;
      &-name {
        // position: absolute;
        // top: 35%;
        // left: 7%;
        font-size: 17px;
        font-weight: 550;
        letter-spacing: 2px;
        padding-left: 20px;
        padding-right: 20px;
        color: #3377fe;
        height: 30px;
        line-height: 30px;
      }
      &-cp {
        // position: absolute;
        // top: 65%;
        // left: 7%;
        font-size: 15px;
        height: 30px;
        line-height: 30px;
        color: #a5a6a5;
      }
    }
    &-btn{
      margin-left: 20px;
      margin-top: 5px;
      height: 20px;
      line-height: 20px;
      border-radius: 5px;
      padding: 0 10px;
      color: #e3e3e3;
      background-color: #3377fe;
    }
    &-time{
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
    }
    &-head {
      height: 80px;
      position: relative;
      background-color: #f6fafd;
      border-bottom: 1px solid #ebeced;
      &-name {
        position: absolute;
        top: 35%;
        left: 7%;
        font-size: 17px;
        font-weight: 550;
        letter-spacing: 2px;
        color: #3377fe;
      }
      &-cp {
        position: absolute;
        top: 65%;
        left: 7%;
        font-size: 15px;
        color: #a5a6a5;
      }
      &-function {
        position: absolute;
        letter-spacing: 0.5px;
        top: 35%;
        right: 5%;
        font-size: 14px;
        color: #f14f29;
      }
      &-starend {
        position: absolute;
        top: 15%;
        left: 6.5%;
        font-size: 16px;
        font-weight: 550;
      }
      &-begintime,
      &-endtime {
        position: absolute;
        font-size: 14px;
        bottom: 35%;
        color: #a5a6a5;
        left: 7%;
      }
      &-endtime {
        bottom: 5%;
      }
      &-right {
        position: absolute;
        font-size: 10px;
        right: 7%;
        top: 40%;
        height: 45px;
        width: 48px;
      }
    }
    &-main {
      height: calc(100% - 120px);
      // background-color: #dddddd;
      position: relative;
      &-body {
        background-color: #f6fafd;
        // padding: 5%;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        &-top {
          padding: 10px;
          box-sizing: border-box;
          background-color: #f6fafd;
          width: 100%;
          height: 130px;
          &-in {
            background-color: #ffffff;
            height: 100%;
            width: 100%;
            &-top {
              width: 100%;
              height: calc(100% - 30px);
              display: flex;
            }
            &-bottom {
              width: 100%;
              height: 30px;
              line-height: 30px;
              border-top: 1px solid #ebeced;
              text-align: center;
              color: #a9acbf;
            }
          }
          &-left {
            width: 100%;
            &-text {
              height: 35%;
              padding-top: 3%;
              font-size: 14px;
              text-align: center;
              box-sizing: border-box;
              font-weight: 550;
              color: #a9acbf;
            }
            &-time,
            &-status {
              height: 30%;
              text-align: center;
              font-size: 15px;
              color: #2070fc;
              padding-top: 5%;
              box-sizing: border-box;
            }
            &-status {
              color: #f4bc38;
              padding-top: 4%;
              box-sizing: border-box;
              font-size: 12px;
            }
          }
          &-mid {
            margin-top: 4%;
            height: 70%;
            width: 0px;
            border-left: 1px solid #e3e3e3;
          }
          &-right {
            width: 50%;
            &-next {
              height: 45%;
              padding-top: 15%;
              font-size: 16px;
              text-align: center;
              box-sizing: border-box;
            }
            &-time {
              height: 30%;
              text-align: center;
              font-size: 15px;
              color: #2070fc;
              padding-top: 5%;
              box-sizing: border-box;
            }
          }
        }
        &-mid {
          padding-top: 3%;
          height: 180%;
          width: auto;
          overflow-y: hidden;
          overflow-x: scroll;
          white-space: nowrap;
          justify-content: space-between;
          background-color: #ffffff;
          // &::-webkit-scrollbar {
          //   display: none;
          // }
          &-item {
            display: inline-block;
            vertical-align: top;
            // float: left;
            width: 20%;
            height: 100%;
            position: relative;
            &:last-child {
              .tw-xlxq-body-main-body-mid-item-line {
                width: 80%;
              }
              .tw-xlxq-body-main-body-mid-item-arrow {
                display: none;
              }
            }
            &-icon {
              // width: 25px;
              height: 15%;
            }

            &-line {
              width: 110%;
              height: 10px;
              background-color: #3bacff;
              border-radius: 10px;
            }
            &-point {
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background-color: #fff;
              position: absolute;
              top: 15.4%;
              left: 35%;
            }
            &-point1 {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background-color: #3bacff;
              position: absolute;
              top: 10%;
              left: 20%;
            }
            &-arrow {
              position: absolute;
              top: 14.8%;
              left: 80%;
            }
            &-text {
              width: 44px;
              padding-left: 25%;
              white-space: normal;
              line-height: 20px;
              text-align: center;
              padding-top: 10%;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
  &-bottom {
    position: absolute;
    bottom: 0%;
    width: 100%;
    height: 30px;
    background-color: #fff;
    &-text {
      font-size: 10px;
      width: 100%;
      padding: 5px 0 0 10px;
      box-sizing: border-box;
    }
    &-bot {
      display: flex;
      // height: calc(100% - 22px);
    }
    &-type {
      width: 25%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.bottom-img {
  width: 25px;
  height: 15px;
  padding-top: 9%;
  padding-bottom: 9%;
  margin-right: 5px;
  // box-sizing: border-box;
}

.item-icon-img {
  transform: rotateY(180deg);
  width: 35px;
  height: 15px;
  display: inline-block;
  padding-top: 15%;
  margin-left: -10px;
}

.item-icon-img1 {
  width: 25px;
  height: 15px;
  padding-top: 15%;
  margin-left: 23px;
}
.lwzj {
  width: 24px;
  // padding-left: 5%;
  white-space: normal;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  padding-top: 5px;
  box-sizing: border-box;
  position: absolute;
  right: 8px;
  top: 20%;
  border: 1px solid #bfbfca;
  border-radius: 5px;
  color: #b6b6c2;
}
.noPc::-webkit-scrollbar {
  display: none;
}
</style>
